import { gql } from "@apollo/client";

export const GET_ORDERS_QUERY = gql`
query GetOrders($filters: OrdersFilters!, $pagination: PaginationRequest!, $sort: [OrderSort!]) {
  order {
    pagination(filters: $filters, sort: $sort, pagination: $pagination) {
      paginationData {
        total
        offset
        limit
      }
      orders {
        salesman {
          id
          fullname
        }
        maxDeliveryDate
        minDeliveryDate
        potentialCustomer {
          id
          status
          email
        }
        items {
          campaignInfo {
            campaign {
              timingStatus
            }
          }
          productID
          productCode
          productName
          price
          quantity
          product {
            productType
          }
        }
        id
        orderType
        createdAt
        number
        subTotal
        total
        promotionType
        customerTotal
        seller {
          id
          fullName
          code
          warehouses {
            id
            name
            branch {
              name
            }
          }
          approvalStatus
        }
        exportedWarehouse {
          name
          id
          branch {
            name
          }
        }
        paymentStatus
        receiverContactName
        receiverContactAddress
        orderPriority
        shippingType
        shippingTypeName
        paymentMethod
        status
        createdBy {
          fullname
          id
          type
        }
        fullStockRequired
        remainingDeliverTime
        vat
        deliveryDeadline
        chatURL
        operationFee
        shippingConfiguration {
          busConfig {
            busName
            busStation
            telephone
            location
            fee
          }
          deliver3PartyConfig {
            name
            fee
            carrierMethod
            provider {
              id
              name
            }
          }
        }
        stockStatus
        fileURLs
        senderAddress
        shipperTelephone
        shipperName
        receiverContactPhone
        note
        cancelReason
        preOrder
        saleChannel {
          name
          type
        }
        fullEvents {
          createdBy {
            type
          }
        }
        messages {
          content
        }
      }
    }
  }
}
`;

export const GET_WAREHOUSES = gql`
{
  warehouse {
    list {
      warehouses {
        name
        id
      }
    }
  }
}
`;

export const GET_WAREHOUSES_WITH_IDS = gql`
query GetWarehouseWithIds($request: WarehouseRequest) {
  warehouse {
    list(request: $request) {
      warehouses {
        name
        id
      }
    }
  }
}
`;

export const GET_CREATED_BY = gql`
query GetCreatedBy($pagination: PaginationRequest, $filters: UsersFilters) {
  user {
    pagination(pagination: $pagination, filters: $filters) {
      paginationData {
        total
        offset
        limit
      }
      users {
        id
        fullname
      }
    }
  }
}
`;

export const GET_ORDER_DETAIL_QUERY = gql`
query GetOrder($id: ID!, $itemDataType: OrderItemDataType) {
  order {
    get(id: $id) {
      needsContractWarning
      salesman {
        id
        fullname
      }
      maxDeliveryDate
      minDeliveryDate
      id
      loyaltyCashDiscount
      status
      potentialCustomer {
        id
        status
        email
      }
      shippingVersion
      number
      promotionType
      accountingNumber
      vatTaxIDNumber
      vatCompanyName
      vatEmail
      vatAddress
      customerVatEmail
      vatCustomerName
      customerVatIDNumber
      customerVatAddress
      preOrder
      shippingStatus
      exportedWarehouse {
        id
        name
        regionID
        branch {
          name
        }
      }
      saleChannel {
        name
        type
      }
      totalPromotionDiscountMoney
      customerShippingFee
      customerTotalServiceProduct
      sellerProfitAmount
      orderReconciliationStatus
      items(itemDataType: $itemDataType) {
        id
        vatPercent
        productID
        productName
        productCode
        quantity
        price
        customerPrice
        total
        customerTotal
        maxDaysOfDebt
        productWarranty
        inStock
        realInStock
        campaignInfo {
          campaign {
            timingStatus
          }
        }
        product {
          vatPercent
          warranty
          warrantyUnit
          stocksSupplier {
            regionID
            region {
              name
            }
            totalQuantity
            vatQuantity
          }
          stocks {
            productID
            quantity
            quantityRealStock
            quantityRealStockHasVat
            warehouse {
              id
              code
              name
              regionID
            }
          }
          uom {
            name
          }
          productType
        }
        vat
        ... on OrderItem {
          preOrder
          originalPrice
          price
          productDiscount
        }
        ... on ComboOrderItem {
          originalPriceOfCombo
          comboOrderItemID
          productID
          promoTierID
          discountMoney
          campaignInfo {
            campaign {
              timingStatus
            }
          }
          promoTier {
            type
            name
          }
          orderItems(showOriginComboItemQuantity: false) {
            product {
              uom {
                id
                name
              }
              stocks {
                productID
                quantity
                quantityRealStock
                quantityRealStockHasVat
                warehouse {
                  id
                  code
                  name
                  regionID
                }
              }
              productType
            }
            id
            productName
            quantity
            vat
            inStock
            price
            total
            productID
            productCode
            customerPrice
            customerTotal
            maxDaysOfDebt
            productWarranty
            realInStock
          }
        }
      }
      sellerID
      seller {
        contractSkipRemaining
        email
        telephone
        address
        availabilityLimit
        fullName
        isActive
        warehouses {
          id
          name
          branch {
            name
          }
        }
        approvalStatus
        users {
          id
          fullname
          email
          telephone
          status
          chatwootContact {
            id
            url
          }
        }
      }
      messages {
        type
        content
        actions
      }
      createdByID
      note
      shippingType
      shippingTypeName
      shippingConfiguration {
        busConfig {
          busName
          telephone
          location
          busStation
          fee
        }
        deliver3PartyConfig {
          name
          fee
          carrierMethod
          carrierMaxFee
          carrierMinFee
          provider {
            id
            name
          }
        }
        urbanConfig {
          fee
        }
      }
      orderPriority
      deliveryDeadline
      chatURL
      fullStockRequired
      shippingFee
      operationFee
      serviceFee
      discount
      exportedWarehouseID
      vat
      vatAllOrder
      discount
      subTotal
      customerSubTotal
      customerTotal
      senderName
      senderPhone
      senderAddress
      receiverContact {
        id
        status
        sellerID
        ward {
          id
        }
        city {
          id
        }
        cityID
        wardID
        telephone
        address
        fullName
        isDefault
        email
      }
      receiverContactName
      receiverContactPhone
      receiverContactAddress
      total
      debtPayment
      stockStatus
      paymentMethod
      paymentStatus
      fileURLs
      email
      fullEvents {
        state
        name
        createdAt
        createdBy {
          fullname
          type
        }
      }
      orderType
      customerPaymentMethod
      shipperTelephone
      shipperName
      cartID
      cancelReason
      totalServiceProduct
      shareLink
      paymentInfo {
        sellerConfirmPaid
      }
      usedPoint
      depositInfo {
        totalDeposit
        totalPaymentAfterDeposit
      }
      bankTransferAccounts {
        id
        qrUrl
      }
      pickupInfo {
        warehouseID
        warehouse {
          id
          name
          address
          city {
            name
          }
          district {
            name
          }
          ward {
            name
          }
        }
        receiver {
          id
          fullName
          phone
        }
      }
    }
  }
}
`;

export const GET_SUMMARY_TABS = gql`
query GetSummaryTabs {
  order {
    totalByStatus {
      all
      waitingForApprovalOrder
      waitingForApprovalStock
      waitingForEnoughStock
      waitingForPayment
      waitingForPackaging
      waitingForExporting
      waitingForAssembly
      waitingForShipping
      delivering
      completed
      canceled
    }
  }
}
`;

export const GET_CREATED_BY_WITH_IDS = gql`
query GetCreatedByWithIds($filters: UsersFilters) {
  user {
    pagination(filters: $filters) {
      users {
        id
        email
        fullname
      }
    }
  }
}
`;

export const GET_ORDER_LOAD_MORE = gql`
query GetOrdersLoadMore($filters: OrdersFilters!, $pagination: PaginationRequest!, $sort: [OrderSort!]) {
  order {
    pagination(filters: $filters, sort: $sort, pagination: $pagination) {
      paginationData {
        total
        offset
        limit
      }
      orders {
        id
        createdAt
        number
        status
        fullEvents {
          state
          name
          createdAt
          createdByID
          createdBy {
            id
            fullname
          }
        }
        seller {
          code
          id
          fullName
          telephone
          address
          email
          city {
            name
          }
          ward {
            name
          }
        }
        exportedWarehouse {
          id
          name
          branch {
            name
          }
        }
        items {
          id
          productID
          warrantyType
          warrantyDateUnit
          productWarranty
          product {
            id
            name
            code
            uom {
              id
              name
            }
          }
          inStock
          warrantyNotes {
            id
            code
            warrantyType
            warrantyOnSale
            warrantyPeriodProviders
            warrantyDateUnit
            serialImei
          }
          quantity
        }
      }
    }
  }
}
`;

export const COUNT_STATUS_ORDER = gql`
query CountStatusOrder($filters: OrdersFilters) {
  order {
    count(filters: $filters)
  }
}
`;

export const GET_ORDER_FILTER_LOAD_MORE = gql`
query GetOrdersFilterLoadMore($filters: OrdersFilters!, $pagination: PaginationRequest!, $sort: [OrderSort!]) {
  order {
    pagination(filters: $filters, sort: $sort, pagination: $pagination) {
      paginationData {
        total
        offset
        limit
      }
      orders {
        id
        number
      }
    }
  }
}
`;

export const GET_POINT_SPLIT_ORDER = gql`
query GetPointSplitOrder($orderID: ID!, $request: [GetPointSplitOrderInput!]) {
  order {
    getPointForSplitOrder(orderID: $orderID, request: $request) {
      code
      point
    }
  }
}
`;
